module.exports = __webpack_public_path__ + "img/event_seat_2.ef40bcbd.svg";